import {Component, Inject, OnInit} from '@angular/core';
import {Test} from '../../../data/models/test/test';
import {TestService} from '../../../services/api/test.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-test-deactivate-dialog',
  templateUrl: './test-deactivate-dialog.component.html',
  styleUrls: ['./test-deactivate-dialog.component.css']
})
export class TestDeactivateDialogComponent implements OnInit {

  test: Test;

  constructor(
    private testService: TestService,
    private dialogRef: MatDialogRef<TestDeactivateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      test: Test,
    },
  ) {
    this.test = data.test;
  }

  ngOnInit(): void {
  }

  onSubmit(): void {
    this.testService.deactivateTest(this.test.id)
      .then(test => {
        this.dialogRef.close(test);
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

}
